export default "<r-card-onboarding #onboardingViews (continueAction)=\"continueAction()\"></r-card-onboarding>\n";